import { Formik, Form } from "formik";
import { useRef, useState } from "react";
import { useEffect } from "react";
import Mixpanel from "mixpanel-browser";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { documentLableAdd } from "../../../features/user-document/document-label";
import {
  getSingleLabel,
  resetGetSingleLabelSlice,
} from "../../../features/user-document/getSingleLabelSlice";
import { labelListing } from "../../../features/user-document/label-listing";
import labelValidations from "../../../validations/label/labelValidations";
import Button from "../../form-components/Button";
import Fields from "../../form-components/Fields";
import "react-dropdown-tree-select/dist/styles.css";
import { getDocuments } from "../../../features/user-document/documentListingSlice";
import NestedSelect from "../NestedSelect";
// import { showSuccess } from "../../../utils/messageHelper";
/* import DropdownTreeSelect from "react-dropdown-tree-select"; */
/* import $ from "jquery"; */



const LabelModal = ({
  isOpen,
  toggle,
  labelID,
  setLabelId,
  selectedLabel,
  selectedCheckbox,
  setSelectedLabel,
  setSelectedCheckbox,
  perPage,
  currentPage,
  setSubCategories,
  currentModal
}) => {
  let dispatch = useDispatch();
  let projectData = JSON.parse(localStorage.getItem("_user"));

  const { singleLabel = null, labelListingData = null } = useSelector(
    (state) => ({
      singleLabel: state?.singleLabelSlice?.responseData?.label,
      labelListingData: state?.labelListingSlice?.responseData?.label,
    })
  );

  /* const handleLabelToggle = () => {
    $(".nested-select").addClass("test");
  }; */

  /* const dropdownRef = useRef(null); */

  /* useEffect(() => {
    if (labelID) {
      dispatch(getSingleLabel(labelID));
    }
  }, []); */

  /*  const nestedLabelOptions = labelListingData?.length > 0 && labelListingData.map((listData, index) => {
        let listingObj = { label: listData.name, value: listData?.uuid };
        return listingObj;
    }) */

  function renameProperties(obj) {
    // Make a copy of the current object
    const newObj = { ...obj };
    // Rename properties of the current object
    newObj.label = newObj.name;
    newObj.value = newObj.uuid;
    /* if(labelID === newObj.uuid){
      newObj.isDefaultValue = true
    } */
    delete newObj.name;
    delete newObj.uuid;

    // Check for SubLabel properties
    if (newObj.SubLabel) {
      // Rename the SubLabel property
      newObj.children = newObj.SubLabel;

      // Recursively rename properties of the sub-labels
      newObj.children = newObj.children.map((subLabel) => {
        return renameProperties(subLabel);
      });

      // Delete the original SubLabel property
      delete newObj.SubLabel;
    }

    return newObj;
  }

  // Make a copy of the top-level objects and rename their properties
  let labelArray =
    labelListingData.length > 0
      ? labelListingData?.map((obj) => {
        return renameProperties(obj);
      })
      : [];
  /* let selectedDropValue = {};
  const onDropdownChange = (currentNode, selectedNodes) => {
    selectedDropValue.selected = selectedNodes;
  };
  const onAction = (node, action) => {
    console.log("onAction::", action, node);
  };
  const onNodeToggle = (currentNode) => {
    console.log("onNodeToggle::", currentNode);
  }; */

  const languageOptions = [
    {
      label: "English",
      value: "English",
    },
  ];

  const labelSubmit = async (values) => {
    /*  let nestedValue = selectedDropValue.selected?.map((data) => data.value);
     values.nested_label = nestedValue ? nestedValue.toString() : ""; */
    if (selectedLabel) {
      let newObj = {};
      newObj.name = values?.label;
      /* newObj.parent_uuid = singleLabel?.uuid; */
      newObj.parent_uuid = selectedLabel;
      newObj.project_uuid = projectData?.projects[0]?.uuid;
      Mixpanel.track("Edit label Button Clicked", {
        Page: "Edit label modal",
      });

      const { payload } = await dispatch(documentLableAdd(newObj));
      if (payload.status === 201) {
        toggle();
        await dispatch(labelListing(projectData?.projects[0]?.uuid));
        setSubCategories("Documents");
        dispatch(
          getDocuments({
            perPage: perPage,
            page: currentPage,
            project_uuid: projectData?.projects[0]?.uuid,
          })
        );
        setSelectedLabel('')
        setLabelId("");
      }
    } else {
      let newObj = {};
      if (values?.nested_checked && values?.nested_label) {
        newObj.name = values?.label;
        /* newObj.parent_uuid = values?.nested_label?.value
          ? values?.nested_label?.value
          : values?.nested_label; */
        newObj.parent_uuid = values?.nested_label;
        newObj.project_uuid = projectData?.projects[0]?.uuid;
      } else {
        newObj.project_uuid = projectData?.projects[0]?.uuid;
        newObj.name = values?.label;
      }

      Mixpanel.track("Add label Button Clicked", {
        Page: "Add label modal",
      });

      const { payload } = await dispatch(documentLableAdd(newObj));
      if (payload.status === 201) {
        setSubCategories("Documents");
        await dispatch(labelListing(projectData?.projects[0]?.uuid));
        toggle();
        dispatch(
          getDocuments({
            perPage: perPage,
            page: currentPage,
            project_uuid: projectData?.projects[0]?.uuid,
          })
        );
        setLabelId("");
      }
    }

  };

  return (
    <>
      <Modal
        className="add-document-popup"
        show={isOpen}
        onHide={toggle}
        // modalTransition={{ timeout: 2000 }}
        dialogClassName="common-modal"
      >
        <Modal.Header>
          <h3 className="modal-title" id="Add_OrganizationLabel">
            New Label
          </h3>

          <Button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              toggle();
              setSelectedLabel('')
              setLabelId("");
              setSelectedCheckbox("");
              dispatch(resetGetSingleLabelSlice());
            }}
          ></Button>
        </Modal.Header>

        <>
          <Formik
            initialValues={{
              label: "",
              language: "english",
              nested_label: selectedLabel || "",
              nested_checked: selectedCheckbox || false,
            }}
            validationSchema={labelValidations}
            onSubmit={labelSubmit}
          >
            {({
              values,
              handleChange,
              handleBlur,
              touched,
              errors,
              isSubmitting,
              handleSubmit,
              setFieldValue,
            }) => {
              const handleSelectChange = (e) => {
                /* $(".nested-select").removeClass("test"); */
                setFieldValue("nested_label", e.target.value)
                if (e.target.value) {
                  setFieldValue("nested_checked", true)
                }
              }
              return (
                <Form>
                  <Modal.Body>
                    <p className="mb-3">
                      New categories should be added in the default language. The
                      default language is set to:
                    </p>
                    <div className="form-group">
                      <div className="form-group">
                        <Select
                          id="inputGroupSelect01"
                          name="language"
                          placeholder="Please select language.."
                          value={{ label: "Language: English", value: "English" }}
                          isDisabled
                          onChange={(value) =>
                            setFieldValue("language", value?.value)
                          }
                          options={languageOptions}
                          classNamePrefix="cmn-control"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="form-group">
                        <label className="form-label">
                          Please enter a new label name:
                        </label>
                        <Fields
                          type="text"
                          placeholder="Enter new label"
                          touched={touched}
                          errors={errors}
                          onBlur={handleBlur}
                          name="label"
                          value={values.label}
                          className="form-control"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="form-check">
                        {/*               <Fields
                          type="checkbox"
                          id="flexCheckChecked"
                          touched={touched}
                          errors={errors}
                          onBlur={handleBlur}
                          name="remember"
                          value={values.remember}
                          className="form-check-input"
                          onChange={handleChange}
                        /> */}
                        <Fields
                          type="checkbox"
                          touched={touched}
                          className="form-check-input"
                          name="nested_checked"
                          onChange={(e) => { handleChange(e); setFieldValue("nested_label", "") }}
                          checked={values?.nested_checked}
                          disabled={labelArray?.length <= 0}
                        />
                        <label className="form-check-label">
                          Nested label under
                        </label>
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="form-group">
                        {/* <DropdownTreeSelect
                        ref={dropdownRef}
                        data={labelArray?.length > 0 ? labelArray : []}
                        onChange={onDropdownChange}
                        onAction={onAction}
                        onNodeToggle={onNodeToggle}
                        mode="multiSelect"
                        texts={{ placeholder: values?.nested_checked === true && !labelID  ? 'Please select a parent...' : '      ' }}
                        disabled={(labelArray?.length > 0 && values?.nested_checked === true) ? false : true}
                      /> */}
                        <div className="nested-select" /* onClick={() => handleLabelToggle()} */>
                          <select onChange={(e) => { handleSelectChange(e); }} name="nested_label" value={values?.nested_label} >
                            {values?.nested_checked === true ? (<option>Please select a parent...</option>) : (<option>{"\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}</option>)}
                            {labelArray.map((data, index) => {
                              return (
                                <>
                                  <NestedSelect key={index} child={data} level={0} />
                                </>
                              )
                            })}
                          </select>
                        </div>
                        {/* <Select
                                                id="inputGroupSelect01"
                                                name="nested_label"
                                                placeholder="Please select a parent.."
                                                defaultValue={selectedLabel}
                                                isDisabled={selectedCheckbox}
                                                onChange={(value )=> {setFieldValue("nested_label", value?.value);}}
                                                options={nestedLabelOptions}
                                                classNamePrefix="cmn-control"
                                            /> */}
                      </div>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      type="submit"
                      disabled={(isSubmitting || (values?.nested_checked === true && (values?.nested_label === "" || values?.nested_label === "Please select a parent...")))}
                      className="btn btn-primary-md"
                      onClick={handleSubmit}
                    >
                      Create
                    </Button>
                  </Modal.Footer>
                </Form>
              )
            }}
          </Formik>
        </>
        {/* <Modal.Footer>
                    <Button type="button" disabled={isLoading} className="btn btn-primary-md" onClick={() => createNewDoc()}>Save</Button>
                </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default LabelModal;
